import React, { useMemo } from "react";
import { Box, Typography, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import actionBarConfig from "../config/heroCardConfig";
import StaticBackground from "./StaticBackground";

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        padding: "16px",
        overflow: "hidden",
        position: "relative",
    },
    addTile: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "16px",
        borderRadius: "8px",
        transition: "background-color 0.3s ease",
        width: "450px",
        height: "400px",
    },
}));

const HeroCard = () => {
    const classes = useStyles();

    const memoizedBackground = useMemo(() => <StaticBackground numShapes={50} />, []);

    return (
        <Box className={classes.container}>
            {memoizedBackground}
            <Paper className={classes.addTile}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    {actionBarConfig.appLogo}
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography sx={{ fontFamily: "'Arial', sans-serif", fontSize: "34px" }}>Racklet</Typography>
                    <Typography
                        sx={{
                            fontFamily: "'Arial', sans-serif",
                            fontSize: "34px",
                            backgroundColor: "#66B2FF",
                            color: "white",
                            borderRadius: "124px",
                            padding: "0 9px",
                        }}
                    >
                        AI
                    </Typography>
                </Box>
            </Paper>
        </Box>
    );
};

export default HeroCard;